import React from "react";
import { get, useFormContext } from "react-hook-form";
import { Input, Alert } from "@material-tailwind/react";

export default function RHFInput({
    className = "bg-none",
    labelProps = {
        // The MT floating label is absolutely positioned and
        // never wraps; cap it at the field edge so an over-long
        // label truncates instead of escaping the input.
        className: "!text-gobbygray font-body max-w-full truncate",
    },
    iconName,
    registerOptions,
    ...props
}) {
    const { register, formState: { errors } } = useFormContext();
    const { ref, ...rest } = register(props.name, registerOptions);
    const error = get(errors, props.name);

    return (
        <>
            <Input
                className={className}
                {...rest}
                {...props}
                inputRef={ref}
                labelProps={labelProps}
                icon={
                    iconName ? (
                        <span className="material-icons text-black text-base leading-none align-middle">
                            {iconName}
                        </span>
                    ) : undefined
                }
                error={!!error}
            />
            {!!error && (
                <Alert color="red" className="mt-1 rounded-lg py-2 px-1 text-sm">
                    {error.message}
                </Alert>
            )}
        </>
    );
}